import {Injectable} from '@angular/core';
import {IAppConfig} from '../models/appConfig/iapp-config';
import {RuntimeContext} from '../models/platform/runtimeContext';
import {KeycloakLv1871Service} from './keycloak-lv1871.service';

@Injectable()
export class UiConfigService {

  public settings: IAppConfig;

  constructor(private _keycloak: KeycloakLv1871Service) {
  }

  public getAntragserfassungUrl(): string {
    if (this._keycloak?.getParameter()?.internalRequest+'' === 'true') {
      this._keycloak.getParameter().internalRequest = true;
    } else {
      this._keycloak.getParameter().internalRequest = false;
    }
    if (this._keycloak.getParameter().runtimeContext === RuntimeContext.STANDALONE &&
        this.settings?.environment?.name === 'PRODUKTION') {
      this._keycloak.getParameter().runtimeContext = RuntimeContext.CMS;
    }
    if (this._keycloak.getParameter().runtimeContext === RuntimeContext.ANGULAR_SHELL) {
      if (!!this._keycloak.isAuthenticated() && this._keycloak.getParameter().internalRequest) {
        return this.settings.host_antragserfassung.url_lan_auth;
      } else if (!!this._keycloak.isAuthenticated() && !this._keycloak.getParameter().internalRequest) {
        return this.settings.host_antragserfassung.url_dmz_auth;
      } else if (this._keycloak.getParameter().internalRequest) {
        return this.settings.host_antragserfassung.url_lan_anon;
      } else {
        return this.settings.host_antragserfassung.url_dmz_anon;
      }
    } else if (this._keycloak.getParameter().runtimeContext === RuntimeContext.CMS) {
      return this.settings.host_antragserfassung.url_dmz_anon;
    } else if (this._keycloak.getParameter().runtimeContext === RuntimeContext.SB_SHELL) {
      return this.settings.host_antragserfassung.url_lan_auth;
    } else {
      return this.settings.host_antragserfassung.url_lan_anon;
    }
  }

  public getAntragserfassungAnonUrl(): string {
    if (this._keycloak?.getParameter()?.internalRequest+'' === 'true') {
      this._keycloak.getParameter().internalRequest = true;
    } else {
      this._keycloak.getParameter().internalRequest = false;
    }
    if (this._keycloak.getParameter().runtimeContext === RuntimeContext.ANGULAR_SHELL) {
      if (this._keycloak.getParameter().internalRequest) {
        return this.settings.host_antragserfassung.url_lan_anon;
      } else {
        return this.settings.host_antragserfassung.url_dmz_anon;
      }
    } else if (this._keycloak.getParameter().runtimeContext === RuntimeContext.CMS) {
      return this.settings.host_antragserfassung.url_dmz_anon;
    } else {
      return this.settings.host_antragserfassung.url_lan_anon;
    }
  }

  public getMatomoConfig(): { consent: boolean; matomo_serverUrl: string; siteId_DMZ: number; siteId_LAN: number } {
    return this.settings.matomo_config;
  }

}
